import * as React from 'react';

export interface PhoneProps {
  phone: string | undefined;
}
export const Phone: React.SFC<PhoneProps> = (props: PhoneProps) => {
  if (!props.phone) {
    return <span>None</span>;
  }
  return <a href={'tel:' + props.phone}>{props.phone}</a>;
};



// WEBPACK FOOTER //
// ./src/common/components/Phone.tsx